import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { iconMappings } from './icon-mappings';

@Injectable({
  providedIn: 'root'
})
export class CustomMatIconRegistryService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  public init(): void {
    this.registerIconSet();
    this.registerIcons();
  }

  private registerIconSet(): void {
    this.matIconRegistry.addSvgIconSet(
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/images/icons.svg'
      )
    );
  }

  private registerIcons(): void {
    Object.entries(iconMappings).forEach(([iconName, iconPath]) => {
      this.matIconRegistry.addSvgIcon(
        iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(iconPath)
      );
    });
  }
}
